<template lang="pug">
.bg-page
  .container
    section
      .title-decoration
        .dot
        .dot
        .dot
        .dot
      h1 {{ $route.meta.title }}
      p.text-center(style="margin-bottom:32px;") 請注意！若為商業使用需經主辦單位同意
    .mb-5
    section
      //- .tab-wrap
        .tab-item(v-for="tab in tabs", @click="tabScroll(tab.offsetTop)") {{ tab.name }}
    .mb-10
    section
      .section-title 2017 WirForce FB 封面圖
      .preview-wrap
        a(href="http://img.wirforce.com.tw/download/fb-cover.jpg", download="fb-cover", title="fb-cover")
          img.preview(src="~assets/download/fb-cover.png")
      .section-title 2017 WirForce 實況素材
      .preview-wrap
        a(href="http://img.wirforce.com.tw/download/live-layout01.png", download="live-layout01", title="live-layout01")
          img.preview(src="~assets/download/live-layout01.png")
        a(href="http://img.wirforce.com.tw/download/live-layout02.png", download="live-layout02", title="live-layout02")
          img.preview(src="~assets/download/live-layout02.png")
        a(href="http://img.wirforce.com.tw/download/live-layout03.png", download="live-layout03", title="live-layout03")
          img.preview(src="~assets/download/live-layout03.png")
        a(href="http://img.wirforce.com.tw/download/live-layout04.png", download="live-layout04", title="live-layout04")
          img.preview(src="~assets/download/live-layout04.png")
        a(href="http://img.wirforce.com.tw/download/live-layout05.png", download="live-layout05", title="live-layout05")
          img.preview(src="~assets/download/live-layout05.png")
        a(href="http://img.wirforce.com.tw/download/live-layout06.png", download="live-layout06", title="live-layout06")
          img.preview(src="~assets/download/live-layout06.png")
        a(href="http://img.wirforce.com.tw/download/live-layout07.png", download="live-layout07", title="live-layout07")
          img.preview(src="~assets/download/live-layout07.png")
        a(href="http://img.wirforce.com.tw/download/live-layout08.png", download="live-layout08", title="live-layout08")
          img.preview(src="~assets/download/live-layout08.png")
        a(href="http://img.wirforce.com.tw/download/live-layout09.png", download="live-layout09", title="live-layout09")
          img.preview(src="~assets/download/live-layout09.png")
        a(href="http://img.wirforce.com.tw/download/live-layout10.png", download="live-layout10", title="live-layout10")
          img.preview(src="~assets/download/live-layout10.png")
      .section-title 2017 WirForce 桌布
      .preview-wrap
        a(href="http://img.wirforce.com.tw/download/wallpaper-01.jpg", download="wallpaper-01", title="wallpaper-01")
          img.preview(src="~assets/download/wallpaper-01.png")
        a(href="http://img.wirforce.com.tw/download/wallpaper-02.jpg", download="wallpaper-02", title="wallpaper-02")
          img.preview(src="~assets/download/wallpaper-02.png")
        a(href="http://img.wirforce.com.tw/download/wallpaper-03.jpg", download="wallpaper-03", title="wallpaper-03")
          img.preview(src="~assets/download/wallpaper-03.png")
        a(href="http://img.wirforce.com.tw/download/wallpaper-04.jpg", download="wallpaper-04", title="wallpaper-04")
          img.preview(src="~assets/download/wallpaper-04.png")
        a(href="http://img.wirforce.com.tw/download/wallpaper-05.jpg", download="wallpaper-05", title="wallpaper-05")
          img.preview(src="~assets/download/wallpaper-05.png")
        a(href="http://img.wirforce.com.tw/download/wallpaper-06.jpg", download="wallpaper-06", title="wallpaper-06")
          img.preview(src="~assets/download/wallpaper-06.png")
        a(href="http://img.wirforce.com.tw/download/wallpaper-07.jpg", download="wallpaper-07", title="wallpaper-07")
          img.preview(src="~assets/download/wallpaper-07.png")
        a(href="http://img.wirforce.com.tw/download/wallpaper-08.jpg", download="wallpaper-08", title="wallpaper-08")
          img.preview(src="~assets/download/wallpaper-08.png")
        a(href="http://img.wirforce.com.tw/download/wallpaper-09.jpg", download="wallpaper-09", title="wallpaper-09")
          img.preview(src="~assets/download/wallpaper-09.png")
        a(href="http://img.wirforce.com.tw/download/wallpaper-10.jpg", download="wallpaper-10", title="wallpaper-10")
          img.preview(src="~assets/download/wallpaper-10.png")
        a(href="http://img.wirforce.com.tw/download/wallpaper-11.jpg", download="wallpaper-11", title="wallpaper-11")
          img.preview(src="~assets/download/wallpaper-11.png")
        a(href="http://img.wirforce.com.tw/download/wallpaper-12.jpg", download="wallpaper-12", title="wallpaper-12")
          img.preview(src="~assets/download/wallpaper-12.png")
      .section-title 2017 WirForce logo
      .preview-wrap
        a(href="http://img.wirforce.com.tw/download/logo-01.png", download="logo-01", title="logo-01")
          img.preview(src="~assets/download/logo-01.png")
        a(href="http://img.wirforce.com.tw/download/logo-02.png", download="logo-02", title="logo-02")
          img.preview(src="~assets/download/logo-02.png")
        a(href="http://img.wirforce.com.tw/download/logo-03.png", download="logo-03", title="logo-03")
          img.preview(src="~assets/download/logo-03.png")
        a(href="http://img.wirforce.com.tw/download/logo-04.png", download="logo-04", title="logo-04")
          img.preview(src="~assets/download/logo-04.png")
        a(href="http://img.wirforce.com.tw/download/logo-05.png", download="logo-05", title="logo-05")
          img.preview(src="~assets/download/logo-05.png")
      .section-title 2017 WirForce 海報
      .preview-wrap
        a(href="http://img.wirforce.com.tw/download/post-01.jpg", download="post-01", title="post-01")
          img.preview(src="~assets/download/post-01.png")
        a(href="http://img.wirforce.com.tw/download/post-02.jpg", download="post-02", title="post-02")
          img.preview(src="~assets/download/post-02.png")
    .mb-40
</template>

<script>
import { mapGetters } from 'vuex'
// import _ from 'lodash'

export default {
  name: 'thanks',
  beforeRouteEnter (to, from, next) {
    next(vm => {
    })
  },
  beforeRouteLeave (to, from, next) {
    next(vm => {
    })
  },
  props: {
    fullScreenCount: {
      type: Object
    },
    isMobile: {
      type: Boolean
    },
    mobileMenuSwitch: {
      type: [Boolean, Function]
    },
    isPortrait: {
      type: Boolean
    }
  },
  data () {
    return {}
  },
  computed: {
    ...mapGetters([
    ])
  },
  methods: {
  },
  mounted () {
    // Place images after loaded
    this.$Lazyload.$on('loaded', () => {
      console.log('Loaded')
    })
  },
  watch: {
  },
  beforeDestroy () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
@import '~stylesheets/variables'
@import '~stylesheets/components'
@import '~stylesheets/mixin'
.preview-wrap
  margin-bottom: 64px
  .preview
    margin: 8px
    max-width: calc(100% - 32px)
</style>



// WEBPACK FOOTER //
// download.vue?7a8b3cf1